import { GradientDivider } from '@ethena/shared-ui/src/components/GradientDivider'
import { Pill } from '@ethena/shared-ui/src/components/Pill'
import Image from 'next/image'
import Link from 'next/link'

import { Fragment } from 'react'

const IMG_DIMENSIONS: Record<string, undefined | { width?: number; height?: number; className?: string }> = {
  '/aave.svg': {
    height: 18,
    width: 90,
  },
  '/bitget.svg': {
    height: 30,
    width: 80,
  },
  '/brevan-howard.svg': {
    height: 15,
    width: 180,
  },
  '/bybit-white.svg': {
    height: 30,
    width: 70,
  },
  '/converge.svg': {
    height: 27,
    width: 115,
  },
  '/deribit-white.svg': {
    height: 40,
    width: 100,
  },
  '/etfetp.svg': {
    height: 27,
    width: 75,
  },
  '/ethena.svg': {
    height: 32,
    width: 100,
  },
  '/hyperliquid-white.svg': {
    height: 32,
    width: 130,
  },
  '/iusde.svg': {
    height: 27,
    width: 95,
  },
  '/mexc.svg': {
    height: 40,
    width: 100,
  },
  '/morpho.svg': {
    height: 26,
    width: 115,
  },
  '/pendle.svg': {
    height: 27,
    width: 115,
  },
  '/wintermute.svg': {
    height: 32,
    width: 160,
  },
}

export const CtaTablet = ({
  links,
  list,
  pills,
  title,
}: {
  pills: string[]
  title: string
  list: { icon: string; text: string }[]
  links: { image: string; alt: string; href?: string }[]
}) => {
  return (
    <article className="rounded-[20px] bg-gradient-to-b from-[#3a3a3a] to-[#09090B] p-[1px] w-full lg:flex-1 lg:last:col-span-2 xl:last:col-span-1">
      <div className="h-full w-full flex items-center justify-center rounded-[20px] bg-background-primary p-2">
        <div className="bg-gradient-to-b from-[#88B4F5] via-[#202a39] to-[#09090B] p-[1px] rounded-[10px] h-full w-full">
          <div className="h-full w-full rounded-[10px] cta-tablet-gradient p-1 relative overflow-hidden">
            <Image
              src="/grid3.png"
              alt="grid"
              fill
              className="absolute top-0 left-0 w-full h-full object-cover opacity-[15%]"
              style={{ transform: 'scale(1.3)' }}
              priority={false}
            />
            <div className="flex flex-col gap-6 px-5 py-8 z-10 relative">
              <div className="flex flex-wrap gap-2 items-center">
                {pills.map(pill => (
                  <Pill key={pill}>
                    <p>{pill}</p>
                  </Pill>
                ))}
              </div>
              <h3 className="text-text-primary text-2xl sm:text-3xl font-medium">{title}</h3>
              <div className="flex flex-col gap-5">
                {list.map(({ icon, text }, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <Image src={icon} alt={text} width={20} height={20} className="h-5 w-5" />
                    <p className="text-text-muted">{text}</p>
                  </div>
                ))}
              </div>
              <GradientDivider variant="horizontal" width="w-[80%]" />
              <div className="flex flex-col gap-8">
                {links.map(({ alt, href, image }, index) => {
                  const { height, width } = IMG_DIMENSIONS[image] ?? {}
                  return (
                    <Fragment key={index}>
                      {href ? (
                        <Link
                          key={index}
                          href={href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="group flex items-center justify-between gap-2 cursor-pointer"
                        >
                          <Image
                            src={image}
                            alt={alt}
                            width={width ?? 120}
                            height={height ?? 32}
                            className="object-contain"
                          />
                          <Image
                            src="/arrow-right.svg"
                            alt="arrow-right"
                            width={16}
                            height={12}
                            className="h-3 w-4 group-hover:translate-x-1 transition duration-300 ease-in-out"
                          />
                        </Link>
                      ) : (
                        <div className="flex flex-wrap items-center justify-between gap-4">
                          <Image
                            src={image}
                            alt={alt}
                            width={width ?? 120}
                            height={height ?? 32}
                            className="object-contain"
                          />
                          <div className="flex items-center justify-center px-5 py-[5px] gap-[10px] rounded-full bg-gradient-to-r from-[rgba(167,194,243,0.20)] to-[rgba(97,113,141,0.20)]">
                            <p className="font-medium capitalize text-sm">Coming Soon</p>
                          </div>
                        </div>
                      )}
                    </Fragment>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  )
}
